var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"full-height"},[_c('v-card-title',[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n      "+_vm._s(_vm.mdiInformation)+"\n    ")]),_vm._v("\n    "+_vm._s(_vm.$t('common.informations'))+"\n  ")],1),_vm._v(" "),_c('v-card-text',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('components.area.description', {
        name: _vm.area.name,
        crags: _vm.area.crags_count,
        routes: _vm.area.routes_figures.routes_count,
        min: _vm.area.routes_figures.grade.min_text,
        max: _vm.area.routes_figures.grade.max_text
      }))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }